// Combine MUI's props with React Router's Link props
import type { CardActionAreaProps } from "@mui/material";
import { CardActionArea } from "@mui/material";
import React from "react";
import type { LinkProps } from "react-router-dom";
import { Link } from "react-router-dom";

type RouterCardAreaProps = CardActionAreaProps & LinkProps;

export function CardLinkArea(props: RouterCardAreaProps) {
  return <CardActionArea component={Link} {...props} />;
}
